import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { dateTime } from "@gravity-ui/date-utils";
import { Slider } from "@gravity-ui/uikit";
/** Длительность слота */
var getRangeSize = function (startRange, endRange) {
    return Math.abs(endRange - startRange);
};
/** Подписи значений, преобразование минут в hh:mm */
var sliderFormatter = function (value) {
    // Проверяем, является ли входное значение числом
    if (typeof value !== "number" || isNaN(value)) {
        return "00:00";
    }
    var hoursValue = value / 60;
    // Получаем целую часть (часы)
    var hours = Math.floor(hoursValue);
    // Получаем дробную часть и преобразуем в минуты
    var minutes = Math.round((hoursValue - hours) * 60);
    // Форматируем часы и минуты, чтобы всегда было 2 цифры
    var formattedHours = hours.toString().padStart(2, "0");
    var formattedMinutes = minutes.toString().padStart(2, "0");
    return "".concat(formattedHours, ":").concat(formattedMinutes);
};
var calcDateTime = function (timeInMinutes) {
    return new Date().setHours(0, timeInMinutes);
};
var normalizeMinuteOffset = function (value) {
    if (value === undefined || value === null || isNaN(value)) {
        return null;
    }
    var normalizedValue = value % 60;
    return normalizedValue >= 0 ? normalizedValue : normalizedValue + 60;
};
var alignToNextAllowedStart = function (timeInMinutes, minuteOffset) {
    var hourStart = Math.floor(timeInMinutes / 60) * 60;
    var currentMinute = ((timeInMinutes % 60) + 60) % 60;
    if (currentMinute === minuteOffset) {
        return timeInMinutes;
    }
    if (currentMinute < minuteOffset) {
        return hourStart + minuteOffset;
    }
    return hourStart + 60 + minuteOffset;
};
var alignToPreviousAllowedStart = function (timeInMinutes, minuteOffset) {
    var hourStart = Math.floor(timeInMinutes / 60) * 60;
    var currentMinute = ((timeInMinutes % 60) + 60) % 60;
    if (currentMinute === minuteOffset) {
        return timeInMinutes;
    }
    if (currentMinute > minuteOffset) {
        return hourStart + minuteOffset;
    }
    return hourStart - 60 + minuteOffset;
};
export var TimeRange = function (props) {
    var _a = useState([
        props.startTimeScale,
        props.startTimeScale + props.minRangeSize,
    ]), sliderValue = _a[0], setSliderValue = _a[1];
    var sliderRef = useRef(null);
    var sliderUpdateCompleteHandler = function (value) {
        var startRange = value[0];
        var endRange = value[1];
        var startMinuteOffset = normalizeMinuteOffset(props.startMinuteOffset);
        startRange = Math.max(startRange, props.startTimeScale);
        if (startMinuteOffset !== null) {
            startRange = alignToNextAllowedStart(startRange, startMinuteOffset);
        }
        // Если длина нового слота меньше минимального, то смещаем конечную дату
        if (getRangeSize(startRange, endRange) < props.minRangeSize) {
            endRange = startRange + props.minRangeSize;
        }
        // Если длина нового слота больше максимального, то смещаем конечную дату
        if (getRangeSize(startRange, endRange) > props.maxRangeSize) {
            endRange = startRange + props.maxRangeSize;
        }
        // Если конечная дата больше ограничения рабочего времени, то смещаем начальную дату
        if (endRange > props.endTimeScale) {
            endRange = props.endTimeScale;
            var latestAllowedStart = startMinuteOffset === null
                ? props.endTimeScale - props.minRangeSize
                : alignToPreviousAllowedStart(props.endTimeScale - props.minRangeSize, startMinuteOffset);
            startRange = Math.max(latestAllowedStart, props.startTimeScale);
        }
        setSliderValue([startRange, endRange]);
        props.onUpdate({
            start: dateTime({
                input: calcDateTime(startRange),
            }),
            end: dateTime({
                input: calcDateTime(endRange),
            }),
        });
    };
    var sliderUpdateHandler = function (value) {
        setSliderValue(value);
        sliderRef.current.blur();
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: { marginBottom: 16, fontSize: 16 }, children: [dateTime({
                        input: calcDateTime(sliderValue[0]),
                    }).format("HH:mm"), " ", "-", " ", dateTime({
                        input: calcDateTime(sliderValue[1]),
                    }).format("HH:mm")] }), _jsx(Slider, { value: sliderValue, step: props.step, min: props.startTimeScale, max: props.endTimeScale, tooltipFormat: sliderFormatter, tooltipDisplay: "on", markFormat: sliderFormatter, onUpdate: sliderUpdateHandler, onUpdateComplete: sliderUpdateCompleteHandler, name: props.name, apiRef: sliderRef })] }));
};
